import { h, Component } from 'preact'
import styled, { css } from 'styled-components'
import { screenLessThan930 } from '../media'
import { Block, SectionHead } from '../layout'
import Support from '../PoliticianDetail/Support'
import { PieChart, ActivityChart } from '../PoliticianDetail/Charts'
import panacekRestNoSupport from '../../assets/panacek-rest-no-support.png'
import Separator from '../layout/Separator'

import arrowDown from '../../assets/arrow-down.png'
import { supportColors } from '../../constants'

const HintContainer = styled.div`
  display: flex;
  text-align: left;
  border-top: 1px solid #ccc;
  padding: 30px 0;
  vertical-align: middle;
  align-items: center;
  line-height: 22px;
  ${screenLessThan930(css`
    flex-direction: column;
    padding: 30px 10px 30px 10px;
  `)};
`

const MultilineHint = HintContainer.extend`
  text-align: center;
  display: block;
`

const Illustration = styled.div`
  flex: 0 0 408px;
  position: relative;
  height: ${props => props.height}px;
  text-align: center;
  ${screenLessThan930(css`
    flex: 0 0 ${props => props.height}px;
  `)};
  > div {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`

const Hint = ({ ilustration, img, children, height }) => (
  <HintContainer>
    {ilustration ? (
      <Illustration height={height}>{ilustration}</Illustration>
    ) : (
      <img alt="" src={img} height={height} width={408} />
    )}
    <div style={{ verticalAlign: 'middle' }}>{children}</div>
  </HintContainer>
)

const ShowMore = styled(Separator)`
  font-size: 20px;
  line-height: 20px;
  cursor: pointer;
  text-decoration: underline;
  :hover {
    text-decoration: none;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    transform: ${props => (props.expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s ease-in-out;
  }
  div {
    display: inline-block;
  }
`

export class Explainer extends Component {
  state = { expanded: false }
  render() {
    return (
      <div>
        <div
          style={{
            textAlign: 'center',
            maxHeight: this.state.expanded ? 1700 : 0,
            transition: 'max-height 1s ease-in-out',
            overflow: 'hidden',
            marginBottom: -20,
          }}
        >
          <div className="subhead" style={{ marginBottom: 30 }}>
            Jak jsme hodnotili?
          </div>
          <Hint
            ilustration={
              <span
                style={{
                  color: '#6a6a6a',
                  fontFamily: 'bariol,arial',
                  backgroundColor: 'transparent',
                  backgroundImage: `url(${panacekRestNoSupport}`,
                  backgroundPosition: 'right',
                  backgroundRepeat: 'no-repeat',
                  backgroundPositionY: 0,
                  backgroundSize: 'contain',
                  paddingRight: 30,
                  fontSize: 25,
                }}
              >
                3x porušil slib
              </span>
            }
            height={25}
          >
            165 poslanců přislíbilo podporovat 9 zákonů, které by zlepšili
            legislativní prostředí v ČR. Tady vidíte, kteří svůj slib dodrželi.
          </Hint>
          <Hint
            ilustration={
              <PieChart
                data={{ green: 47.2, grey: 15.8, red: 37 }}
                gender="M"
                title="Hlasování"
              />
            }
            height={150}
          >
            O každém zákoně se hlasuje mnohokrát. Od toho zda se zákon dnes bude
            projednávat, přes pozměňující návrhy, až po přehlasování Senátu. Zde
            vidíte v kolika procentech politik podporovat a kdy naopak hlasoval
            pro jeho oslabení, nebo proti jeho přijetí.<br />
            Každé hlasování je samozřejmě v legislativním procesu jinak
            důležité. Proto jinak promlouvá do výsledku hodnocení. Váhu
            jednotlivých hlasování si vždy můžete prohlédnout dole v tabulce
            &bdquo;hlasování podrobně&ldquo;.
          </Hint>
          <Hint
            ilustration={
              <ActivityChart nospace data={{ green: 20, red: 10 }} />
            }
            height={130}
          >
            Práce parlamentních politiků ale není jen o hlasování. Kdo zákony
            opravdu aktivně prosazoval (nebo naopak blokoval) je dobře vidět
            právě na další aktivitě. Tam spadá hlavně navrhování jednotlivých
            tisků a pozměňujících návrhů, ale i vyjednávání podpory u opozice či
            ve vládě, navrhování, či blokování projednávání na plénu a podobně.
          </Hint>
          <Hint
            ilustration={
              <PieChart
                data={{ green: 25.8, grey: 51.2, red: 23 }}
                gender="M"
                title="Celkově"
              />
            }
            height={150}
          >
            Celkové hodnocení shrnuje hodnocení za aktivitu i hlasování. U
            poslanců mají obě složky vliv 50%. U senátorů má hlasování vliv 75%
            což odráží jinou roli horní komory v legislativním procesu.
          </Hint>
          <MultilineHint height={52}>
            <div>Tady je jedním slovem shrnuto co zobrazují čísla a grafy.</div>
            <div>
              {Object.keys(supportColors).map(k => (
                <Support small support={k} />
              ))}
            </div>
          </MultilineHint>
          <MultilineHint>
            Pokud Vás zajímají detaily našeho hodnocení, neváhejte se ponořit do{' '}
            <a href="https://pimcore.rekonstrukcestatu.cz/na-stazeni/metodika_hodnoceni.pdf">
              metodiky pro geeky
            </a>.
          </MultilineHint>
        </div>
        <ShowMore
          bg="white"
          expanded={this.state.expanded}
          onClick={() =>
            console.log('ShowMore') ||
            this.setState({ expanded: !this.state.expanded })}
        >
          <div>
            <img src={arrowDown} alt="" />
            Jak jsme hodnotili
          </div>
        </ShowMore>
      </div>
    )
  }
}

export default class PoliticianListIntro extends Component {
  render() {
    return (
      <Block style={{ padding: 0 }}>
        <SectionHead head="Kteří politici dodrželi slovo?">
          Podrobné hodnocení všech poslanců za volební období<br />2013-2017
        </SectionHead>
        <div style={{ textAlign: 'center' }}>
          <p>
            <span>
              Poslanci před volbami 2013 slíbili, že prosadí protikorupční
              zákony, které ušetří miliardy. Následující 4 roky jsme sledovali
              každé jejich hlasování a máme data o tom, kdo svoje slovo dodržel.
            </span>
          </p>
          <p>
            <span>
              Podívejte se, jak si vedli politici. A přečtěte si také{' '}
              <a href="http://pimcore.rekonstrukcestatu.cz/cs/archiv-novinek/11777-protikorupcni-zakony-jak-si-vedla-vlada-">
                zhodnocení vlády
              </a>.
            </span>
          </p>
        </div>
        <Explainer />
      </Block>
    )
  }
}



// WEBPACK FOOTER //
// ./components/PoliticianList/PoliticianListIntro.js